import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {Injectable} from '@angular/core';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogService} from '@shared/services/dialog-service';
import {take, takeUntil} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {TaskManagerService} from './task-manager.service';
import {TaskReadOnlyStatus} from '@features/task-manager/models/task-manager.model';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class OpenTaskCommandHandler implements IPlatformCommandHandler {
  private checkedItemCount: number;
  private unsubscribe$: Subject<void>;

  constructor(
    private commandService: CommandService,
    private router: Router,
    private dialogService: DialogService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private snackBarService: SnackBarService,
    private particleCacheService: ParticleCacheService,
    private taskManagerService: TaskManagerService,
    private queryStore: Store<IQueryState>,
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.unsubscribe$ = new Subject<void>();
    this.checkedItemCount = 0;
    const taskId = command.fieldValues['TaskId'];
    const taskMenuDetailId = command.fieldValues['SelectedMenuId'];
    const scope = command.fieldValues['Scope'] ? command.fieldValues['Scope'] : 0;
    const taskMenuDetails: any = {}; // new TaskMenuDetails();
    taskMenuDetails.id = taskMenuDetailId; // command.fieldValues['SelectedMenuId'];
    const taskReadOnlyStatus = new TaskReadOnlyStatus();
    taskReadOnlyStatus.CheckList['CanEditCheckList'] = command.fieldValues['IsReadOnly'];
    if (command.fieldValues['NodeId']) {
      this.subscribeToCheckListChanges();
    }
    this.taskManagerService.openTaskByTaskId(taskId, GraphqlContentScope.getScope(scope), null, null, taskMenuDetails, false, taskReadOnlyStatus, {
      'command': command,
      'handler': handler,
      'taskApi': 'FlowApi'
    })
      .pipe(take(1)).subscribe(state => {
      console.log('We need to update the task information in the buttons', state);
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
      if (command.api && command.api.length > 0 && !command.isDisabled) {
        this.fuseSplashScreenService.show();
        command.fieldValues['CheckedItemCount'] = this.checkedItemCount;
        this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
            console.log('[PlatformCommand] Command Response', commandResponse);
            if (commandResponse.fieldValues['SnackBarMessage']) {
              const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
            }
            if (commandResponse.fieldValues['RedirectUrl']) {
              this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
              if (handler && handler.invalidateSubject) {
                handler.invalidateSubject.invalidate('Refresh');
              }
            } else {
              if (handler && handler.invalidateSubject) {
                handler.invalidateSubject.invalidate('Refresh');
              }
            }
            this.fuseSplashScreenService.hide();
            if (callback) {
              callback();
            }
          },
          error => {
            console.error('Failed ToolBarComponent command', error);
            this.fuseSplashScreenService.hide();
          });
      }
      return true;
    });
    return false;
  }

  private subscribeToCheckListChanges() {
    const key = 'ChecklistKey';
    const checklists$ = this.queryStore.pipe(select(getQueryResponse, key));
    checklists$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      console.log('CheckList: ', state);
      if (state) {
        this.checkedItemCount = state[0].checkedItemCount;
      }
    });
  }
}
